import Bag from "./assets/bag.png"
import BasketBall from "./assets/basketball.png"
import Tshirt from "./assets/red tshirt.png"
import Slider1 from "./assets/cart.png"
import Slider2 from "./assets/dressstore.png"
import Slider3 from "./assets/onlineshopping.png"
import Step1 from "./assets/step1.jpg"
import Step2 from "./assets/step2.jpg"
import Step3 from "./assets/step3.jpg"
import Step4 from "./assets/step4.jpg"

export const cardDetails = [
    {
        title : "Explore new arrivals",
        heading : "Shop the latest brands",
        color : "#DAF5FF",
        img : Tshirt,
        catergory : "men"
    },
    {
        title : "Digital gift cards",
        heading : "Give the gift of choice",
        color : "#FA9884",
        img : BasketBall,
        catergory : "sports"
    },
    {
        title : "Sale collection",
        heading : "Upto 80% of retail",
        color : "#F6F1E9",
        img : Bag,
        catergory : "women"
    }
]

export const posterImg = [
    {
        img : Slider1
    },
    {
        img : Slider2
    },
    {
        img : Slider3
    }
]

export const products = [
    {
        id : 1,
        name : "Lether T-shirt",
        sub : "perfect men outfit",
        img : "https://i.ibb.co/yfWkwFJ/blue-Tshirt.png",
        price : 225
    },
    {
        id : 2,
        name : "Royal Men pant",
        sub : "Men Military green",
        img : "https://i.ibb.co/ctxbxJD/pant.png",
        price : 699
    },
    {
        id : 3,
        name : "HPM Hand Bag for girls",
        sub : "Dark Brown",
        img : "https://i.ibb.co/H476nmc/handbag.png",
        price : 499
    },
    {
        id : 4,
        name : "Makeup kit",
        sub : "Girls makeup kit",
        img : "https://i.ibb.co/xCNQ92L/makeup.png",
        price : 899
    },
    {
        id : 5,
        name : "Blue Shirt",
        sub : "perfect men outfit",
        img : "https://i.ibb.co/qdH0fPV/shirt1.png",
        price : 225
    },
    {
        id : 6,
        name : "Orange Hoodie",
        sub : "Hoodie",
        img : "https://i.ibb.co/KKr9Pdj/shirt4.png",
        price : 699
    },
    {
        id : 7,
        name : "White Tshirt",
        sub : "White outfit",
        img : "https://i.ibb.co/SKSHZYs/shirt6.png",
        price : 499
    },
    {
        id : 8,
        name : "Red Tshirt",
        sub : "Men casual fit",
        img : "https://i.ibb.co/3W98GRP/shirt7.png",
        price : 899
    },
    {
        id : 9,
        name : "Black Hoodie",
        sub : "Hoodie",
        img : "https://i.ibb.co/pKx1tjc/shirt8.png",
        price : 225
    },
    {
        id : 10,
        name : "Torn Jeans",
        sub : "Blue jean",
        img : "https://i.ibb.co/68z1R9s/jean2.png",
        price : 699
    },
    {
        id : 11,
        name : "Blue Jeans",
        sub : "Jean",
        img : "https://i.ibb.co/wyfyX4s/jean3.png",
        price : 499
    },
    {
        id : 12,
        name : "Nivia basket ball",
        sub : "Basket ball",
        img : "https://i.ibb.co/dL6mKy8/basket-ball.png",
        price : 899
    },
    {
        id : 13,
        name : "Nike Shoe",
        sub : "Men sports shoe",
        img : "https://i.ibb.co/nDtWjqM/shoe.png",
        price : 699
    }

]

export const stepsList = [
    {
        step : "Step 1",
        title : "Filter & Discover",
        color : "#FFABAB",
        img : Step1
    },
    {
        step : "Step 2",
        title : "Add to bag",
        color :"#E5E0FF",
        img : Step2
    },
    {
        step : "Step 3",
        title : "Fast Shipping",
        color : "#FDF7C3",
        img : Step3
    },
    {
        step : "Step 4",
        title : "Enjoy the product",
        color : "#E5BEEC",
        img : Step4
    }
]